import React from 'react'
import { Link } from 'react-router-dom'
import Buscador from '../../Reutilizables/buscador/Buscador'
import ContadorVisitas from '../../Reutilizables/ContadorVisitas'
import "../../../styles/registrado/inicioSuscrito/MenuInicioSuscrito.css"

function MenuInicioSuscrito() {
  return (
    <div className="navbar-suscrito">

       <div className='nav-todo-suscrito'>
       <div>
          <Link to="/" className='nav-link'>Inicio</Link>
        </div>

        <div className="subnav">
          <button className="subnavbtn">Quienes somos <i className="fa fa-caret-down"></i></button>
          <div className="subnav-content">
            <Link to="/nuestra-firma" className='nav-link'>Nuestra firma</Link>
            <Link to="/mision-y-vision" className='nav-link'>Misión y Visión</Link>
          </div>
        </div> 

        <div>
          <Link to="/servicios" className='nav-link'>Servicios</Link>
        </div>

        <Link to="/contacto" className='nav-link'>Contactenos</Link>

        <Link to="/nuestros-clientes" className='nav-link'>Nuestros clientes</Link>

        <Link to="/blog-tributos-y-finanzas" className='nav-link'>Nuestros Blog</Link>

        <ContadorVisitas />

        <div className='search-menu-sus'>
          <Buscador/>
        </div>

       </div>

      </div>
  )
}

export default MenuInicioSuscrito